import { render } from "./C4NoRobots.vue?vue&type=template&id=4cc254ab"
import script from "./C4NoRobots.vue?vue&type=script&lang=js"
export * from "./C4NoRobots.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__